class Delete {
  constructor(id, cpf, userCreation, descriptionCreation, dateCreation, statusCreation, userModification, descriptionModification, dateModification, statusModification, userSecurity, descriptionSecurity, dateSecurity, statusSecurity, process, securityOnly) {
    this.id = id
    this.cpf = cpf
    this.userCreation = userCreation
    this.descriptionCreation = descriptionCreation
    this.dateCreation = dateCreation
    this.statusCreation = statusCreation
    this.userModification = userModification
    this.descriptionModification = descriptionModification
    this.dateModification = dateModification
    this.statusModification = statusModification
    this.userSecurity = userSecurity
    this.descriptionSecurity = descriptionSecurity
    this.dateSecurity = dateSecurity
    this.statusSecurity = statusSecurity
    this.process = process
    this.securityOnly = securityOnly
  }
}
export {
    Delete as default
}




// WEBPACK FOOTER //
// ./src/model/Delete.js